import axios from 'axios'
import {ID} from '../../../../../_metronic/helpers'
import {ResponseObjectPaginated, ResponseObjectUpload} from '../../../models'
import {
  BillingDocument,
  GetBillingDto,
  GetSaveBillingDto,
  MasterBillingDocument,
  SaveBillingModel,
} from '../models/billing.model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getListBillingService(dto: GetBillingDto) {
  return axios.post<ResponseObjectPaginated<BillingDocument[]>>(
    `${BASEURL}/billing/getBillingReport`,
    dto,
  )
}

export function getListBillingDetailService(
  reportFacturationId: string,
  page: number,
  size: number,
) {
  return axios.get<ResponseObjectPaginated<BillingDocument[]>>(
    `${BASEURL}/billing/getListBillingReportDetail?reporteFacturacionCabId=${reportFacturationId}&pageNumber=${page}&size=${size}`,
  )
}

export function getListBillingMasterService(dto: GetSaveBillingDto) {
  return axios.post<ResponseObjectPaginated<MasterBillingDocument[]>>(
    `${BASEURL}/billing/getListBillingReportMaster`,
    dto,
  )
}

export function getListBillingExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/billing/getBillingReportExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getListBillingCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/billing/getBillingReportCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getListBillingPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/billing/getBillingReportPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

export function createSaveReportBillingService(dto: SaveBillingModel) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/billing/createBillingReport`, dto)
}

export function getListBillingDetailExcelService(id: ID) {
  return axios.get<any>(
    `${BASEURL}/billing/getBillingReportSavedExcel?reporteFacturacionCabId=${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function getListBillingDetailCSVService(id: ID) {
  return axios.get<any>(
    `${BASEURL}/billing/getBillingReportSavedCSV?reporteFacturacionCabId=${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/csv',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function getListBillingDetailPDFService(id: ID) {
  return axios.get<any>(
    `${BASEURL}/billing/getBillingReportSavedPDF?reporteFacturacionCabId=${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
      responseType: 'arraybuffer',
    },
  )
}
